import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Company } from '@models/company';
import { CondoCorp, CondoManagement } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { cloneDeep, isEqual } from 'lodash';

export enum DispatchTypes {
	CONDO_CORP = 'CONDO_CORP',
	CONDO_MANAGEMENT = 'CONDO_MANAGEMENT',
}

export interface CondoCorporationModalData {
	name: string;
	dispatchType: DispatchTypes;
	condoCorpId: string;
	condoCorporation: CondoCorp;
	company: CondoCorp | CondoManagement;
}

@Component({
	selector: 'app-condo-corporation-modal',
	templateUrl: './condo-corporation-modal.component.html',
	standalone: false,
})
export class CondoCorporationModalComponent implements OnInit {
	@Input() name: string;
	@SelectSnapshot(SelectedMatter.id) matterId;

	private dispatchType;
	public company: CondoCorp | CondoManagement;
	private uneditCompany: Company;
	private condoCorpId: string;
	private condoCorporation: CondoCorp;
	public label: string = '';
	constructor(
		private matterDispatch: MatterDispatch,
		public dialogRef: MatDialogRef<CondoCorporationModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: CondoCorporationModalData,
	) {}

	ngOnInit(): void {
		this.name = this.data.company ? this.data.company.name : this.data.name;
		this.dispatchType = this.data.dispatchType;
		this.company = this.data.company ?? null;
		this.condoCorpId = this.data.condoCorpId ?? null;
		this.condoCorporation = this.data.condoCorporation ?? null;
		this.uneditCompany = cloneDeep(this.data.company);
		if (this.dispatchType === DispatchTypes.CONDO_CORP) {
			this.label = this.condoCorporation
				? 'Edit a condo corporation'
				: 'Add a condo corporation';
		} else {
			this.label = this.company
				? 'Edit a management company'
				: 'Add a management company';
		}
	}

	onSubmit(company: CondoCorp | CondoManagement) {
		if (this.uneditCompany) {
			this.uneditCompany.googlePlaceId = undefined;
			(this.uneditCompany as CondoCorp).managementId = undefined;
		}

		if (!isEqual(company, this.uneditCompany)) {
			if (this.dispatchType === DispatchTypes.CONDO_CORP) {
				this.matterDispatch.CreateCondoCorporationCompany(
					this.matterId,
					company,
				);
			} else if (this.dispatchType === DispatchTypes.CONDO_MANAGEMENT) {
				this.matterDispatch.CreateCondoCorporationManagement(
					this.matterId,
					company,
					this.condoCorpId,
					this.condoCorporation,
				);
			}
		}

		this.dialogRef.close();
	}

	onCancel() {
		this.dialogRef.close();
	}
}
